import { ReactNode } from 'react';
import cl from 'clsx';

import classes from './BotPermissionsImage.module.scss';

type LineProps = {
  children: ReactNode;
  checked: boolean;
};
const Line = ({ checked, children }: LineProps) => (
  <div className={cl(classes.line, { [classes.unchecked]: !checked })}>
    <div className={classes.text}>{children}</div>
    <div className={cl(classes.switch)}>
      <div className={classes.thumb} />
    </div>
  </div>
);

type PermissionInfo = [name: string, checked: boolean];

const DATA = [
  ['Изменение профиля канала', false],
  ['Управление сообщениями', false],
  ['Управление историями', false],
  ['Добавление подписчиков', true],
  ['Управление сообщениями каналу', false],
  ['Управление трансляциями', false],
  ['Назначение администраторов', false],
] satisfies PermissionInfo[];

export const BotPermissionsImage = () => (
  <div className={classes.root}>
    {DATA.map(([text, checked], index) => (
      <Line key={index} checked={checked}>
        {text}
      </Line>
    ))}
  </div>
);
